import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';
import { buildLocationAPIPayload } from 'store/utils/userLocation.utils';

export const skiApi = createApi({
  reducerPath: 'skiApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['SkiWeather'],
  endpoints: (builder) => ({
    getSkiReports: builder.query({
      query: (location) => ({
        url: '/v2/custom-weather/ski-resorts',
        params: buildLocationAPIPayload(location),
      }),
      transformResponse: (response) => response?.result,
      providesTags: ['SkiWeather'],
    }),
  }),
});

export const { useGetSkiReportsQuery } = skiApi;
